import { render, staticRenderFns } from "./CustomerInfoModal.vue?vue&type=template&id=6c125691&scoped=true&"
import script from "./CustomerInfoModal.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoModal.vue?vue&type=style&index=0&id=6c125691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c125691",
  null
  
)

export default component.exports